import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const KundensortimenteServiceConfig = {
  name: "Kundensortimente",
  annotations: []
} as ServiceConfig;